import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { validateToken, setInitialized } from "../../store/slices/authSlice";
import { loginToRewardsHub } from "../../store/slices/RewardsHubSlice";

/**
 * Simplified SessionSyncProvider that focuses on initial session validation
 * Token refresh is now handled by axios interceptor
 * Also initializes RewardsHub on app load
 */
export const SessionSyncProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { user, isAuthenticated, token, initializing } = useSelector((state) => state.auth);
  const { initialized: rewardsHubInitialized } = useSelector((state) => state.rewardsHub);
  const hasInitialized = useRef(false);

  // Initial session validation
  useEffect(() => {
    console.log("🔄 SessionSync: Initializing session validation");

    if (!hasInitialized.current) {
      const storedToken = localStorage.getItem("token");

      if (storedToken) {
        console.log("🔄 SessionSync: Found stored token, validating...");
        dispatch(validateToken());
      } else {
        console.log("ℹ️ SessionSync: No token found, marking as initialized");
        dispatch(setInitialized());
      }

      hasInitialized.current = true;
      console.log("🔄 SessionSync: Session validation completed");
    }
  }, [dispatch]);

  // Initialize RewardsHub AFTER session validation is complete
  useEffect(() => {
    // Only initialize RewardsHub after auth initialization is complete (initializing = false)
    if (!initializing && !rewardsHubInitialized) {
      console.log("🎁 SessionSync: Auth initialized, now initializing RewardsHub...");

      const consumerIdPrefix = import.meta.env.VITE_ENVIRONMENT === "development" ? "buy-now-stg" : "buy-now-test";

      dispatch(loginToRewardsHub({
        consumerId: `${consumerIdPrefix}-${user?.customer_id}`,
        // consumerId: `EFU-LIFE-${user?.customer_id}`,
        phone: user?.msisdn
      }));
    }
  }, [dispatch, initializing, rewardsHubInitialized]);

  // Simplified periodic validation (every 15 minutes when user is active)
  // useEffect(() => {
  //   if (isAuthenticated && token) {
  //     const interval = setInterval(() => {
  //       if (document.visibilityState === "visible") {
  //         console.log("🔄 SessionSync: Periodic token validation");
  //         dispatch(validateToken()).catch((error) => {
  //           console.warn(
  //             "⚠️ SessionSync: Periodic validation failed, will be handled by interceptor:",
  //             error
  //           );
  //         });
  //       }
  //     }, 15 * 60 * 1000); // 15 minutes

  //     return () => clearInterval(interval);
  //   }
  // }, [isAuthenticated, token, dispatch]);

  return children;
};

export default SessionSyncProvider;
